export default "__VITE_ASSET__8c8932da__"